module.exports = __webpack_public_path__ + "static/img/MnavCY@2x.9642ce38.png";